import { Sparkles, Wrench, Bug } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import changelog from "../data/changelog";

const TYPE_CONFIG: Record<string, { label: string; icon: LucideIcon; className: string }> = {
  new:      { label: "New",      icon: Sparkles, className: "bg-blue-50 text-blue-700 border-blue-200" },
  improved: { label: "Improved", icon: Wrench,   className: "bg-green-50 text-green-700 border-green-200" },
  fixed:    { label: "Fixed",    icon: Bug,       className: "bg-amber-50 text-amber-700 border-amber-200" },
};

function Badge({ type }: { type: string }) {
  const cfg = TYPE_CONFIG[type] ?? TYPE_CONFIG.new;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${cfg.className}`}>
      <Icon size={10} />
      {cfg.label}
    </span>
  );
}

export default function ChangelogPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-8 md:px-6">
      <h1 className="mb-1 text-2xl font-bold text-gray-900">What's new</h1>
      <p className="mb-8 text-sm text-gray-500">Release notes and updates</p>

      <div className="space-y-8">
        {changelog.map((release) => (
          <div key={release.version} className="relative">
            {/* Version header */}
            <div className="mb-4 flex items-center gap-3">
              <span className="rounded-lg bg-[#1D345F] px-3 py-1 text-sm font-bold text-white">
                v{release.version}
              </span>
              <span className="text-sm text-gray-500">{release.date}</span>
              {release.highlights && (
                <span className="text-sm font-medium text-gray-700">— {release.highlights}</span>
              )}
            </div>

            {/* Changes */}
            <ul className="space-y-3">
              {release.changes.map((change, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Badge type={change.type} />
                  <span className="text-sm text-gray-700 leading-relaxed">{change.text}</span>
                </li>
              ))}
            </ul>

            {/* Divider (not on last) */}
            {changelog.indexOf(release) < changelog.length - 1 && (
              <div className="mt-8 border-t border-gray-200" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
